export default {
  box: {
    maximize: 'Maximalizovat',
    minimize: 'Minimalizovat'
  }
}
